import util from '@bmp-vue/core/api/util'
import api from '@/utils/api'

const controller = 'Autenticacao'
const controllerVersionado = 'v1.0/Autenticacao'

const metodoExterno = {
  Autenticar: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post('v1.0/' + controller + '/AccessToken', dto)
  },

  Logout: function () {
    return util.Axios.Delete('v1.0/' + controller + '/Logout')
  },

  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post('v1.0/' + controller + '/RefreshToken', dto)
  },

  RevokeRefreshToken: function (token) {
    return util.Axios.Delete('v1.0/' + controller + '/RefreshToken/' + token)
  },

  SolicitarLinkSenha: function (model) {
    return util.Axios.Post(`v1.0/${controller}/SolicitarLinkSenha/${encodeURIComponent(model.email)}`);
  }

}

const metodoInterno = {

  ValidarTokenRecuperacao: function (usuario, token) {
    return api.Axios.Get(`${controllerVersionado}/ValidarTokenSenha?usuario=${encodeURIComponent(usuario)}&token=${encodeURIComponent(token)}`)
  },

  RecuperarSenha: function (model) {
    var dto = {
      Password: model.password,
      ConfirmPassword: model.confirmPassword,
      Code: model.code
    }

    return api.Axios.Post(
      controllerVersionado + '/RecuperarSenha/' + encodeURIComponent(model.email), dto)
  }
}

export default Object.assign(
  {},
  util.GetCrud(controller, ['none']),
  metodoExterno,
  metodoInterno
)